
import { Vue, Component } from 'vue-property-decorator'

import UiScreenType, { UiModeBreakpoints } from '@/models/ui-screen-type'

import { UtilityGetters, UtilityMutationTypes } from '@/store/modules/utility'

@Component
export default class UiScreenTypeMixin extends Vue {
  mounted() {
    window.addEventListener('resize', this.calculateWidth.bind(this))
    this.calculateWidth()
  }

  calculateWidth() {
    const width = window.innerWidth
    const { screenType, isRetina } = this

    const currentIsRetina = window.devicePixelRatio > 1.3
    let currentScreenType

    if (width > UiModeBreakpoints.desktop) {
      currentScreenType = UiScreenType.Desktop
    } else if (width > UiModeBreakpoints.tablet) {
      currentScreenType = UiScreenType.Tablet
    } else if (width > UiModeBreakpoints.mobileLandscape) {
      currentScreenType = UiScreenType.MobileLandscape
    } else {
      currentScreenType = UiScreenType.Mobile
    }

    if (currentScreenType !== screenType) {
      this.$store.commit(
        UtilityMutationTypes.SetUiScreenType,
        currentScreenType,
      )
    }

    if (currentIsRetina !== isRetina) {
      this.$store.commit(UtilityMutationTypes.SetIsRetina, isRetina)
    }
  }

  get screenType(): string {
    return this.$store.getters[UtilityGetters.UiScreenType]
  }

  get isRetina(): boolean {
    return this.$store.getters[UtilityGetters.IsRetina]
  }

  onResize() {
    this.calculateWidth()
  }
}
